export default {
  'menu-nav': {
    menu: 'Menu',
    'ciders-and-spirits': 'Sidri',
    'high-altitude': 'Alta quota',
    'savoir-faire': 'Savoir-faire',
    contacts: 'Entra in contatto',
    home: 'Home',
    back: 'Back',
  },
  news: 'Novità',
}
